export default "__VITE_ASSET__8b8894c4__"